import React from 'react';
import { t } from '../../../jsCore/providers/i18nProvider/i18nProvider';
const blockName = 'scores-table';
const TABLE_CELL_CLASS_NAME = `${blockName}__cell`;
const ROW_CLASS_NAME = `${blockName}__row`;
const ROW_PROMOTED_CLASS_NAMES = `${ROW_CLASS_NAME} ${ROW_CLASS_NAME}--promoted`;
const TABLE_COLUMN_HEADINGS = [ 'Pos', 'Team', 'P', 'GD', 'Pts' ];

/* eslint-disable camelcase */
function getPartitionClassName(index, { table_bottom: tableBottom, table_top: tableTop }, tableLength) {
  const promotedIndexes = [ tableBottom && tableLength - tableBottom, tableTop ];
  return promotedIndexes.includes(index + 1) ? ROW_PROMOTED_CLASS_NAMES : ROW_CLASS_NAME;
}


function getTableCell({ tagName, className }, cellData, key) {
  return React.createElement(tagName, { className, key }, cellData);
}

function getCellList(cellListData, cellConfig){
  return cellListData.map(getTableCell.part(cellConfig));
}

function getTableRows({ teams, partition }) {
  return teams.map((row, index, teamsList) => {
    const { name: teamName, games_played: gamesPlayed, goal_diff: goalDiff, points } = row;
    return (
      <tr key={ index } className={ getPartitionClassName(index, partition, teamsList.length) }>
        {
          getCellList(
            [
              index + 1,
              teamName,
              gamesPlayed,
              goalDiff,
              points
            ], {
              tagName: 'td',
              className: TABLE_CELL_CLASS_NAME
            }
          )
        }
      </tr>
    );
  });
}

/* eslint-enable camelcase */

export function ScoresTable({ table }) {
  const TABLE_CELL_HEADER = `${TABLE_CELL_CLASS_NAME} ${TABLE_CELL_CLASS_NAME}--header`;
  return (
    <table className={ `${blockName}__table` }>
      <tbody>
        <tr>
          <th colSpan="5" className={ `${blockName}__top-header` }>
            <h2 className={ `${blockName}__title` }>{ t('common.table') }</h2>
          </th>
        </tr>
        <tr className={ `${blockName}__header` }>
          {
            getCellList(
              TABLE_COLUMN_HEADINGS, {
                tagName: 'th',
                className: TABLE_CELL_HEADER
              }
            )
          }
        </tr>
        { getTableRows(table) }
      </tbody>
    </table>
  );
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/scores_table/components/scoresTable.js